var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Edit Square",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 21.666 21.666"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Edit Square",
    d: "M6.129 21.666c-3.6 0-6.017-2.506-6.125-6.136V6.432C0 2.753 2.343.161 5.88.045h4.233a.8.8 0 01.108 1.588l-.108.007H6.129A4.332 4.332 0 001.6 6.179v9.097c0 2.826 1.656 4.684 4.289 4.791h9.642a4.327 4.327 0 004.528-4.542V10.991a.8.8 0 011.59-.108l.008.108v4.284c0 3.683-2.336 6.271-5.881 6.387h-.25zm.371-5.785a.8.8 0 01-.8-.818l.1-4.021a3.093 3.093 0 01.911-2.118l7.96-7.949a3.345 3.345 0 014.721 0l1.3 1.295a3.33 3.33 0 010 4.714l-8 7.986a3.094 3.094 0 01-2.2.911zm1.342-5.829a1.5 1.5 0 00-.443 1.03l-.081 3.2h3.173a1.523 1.523 0 00.959-.342l.111-.1 6.215-6.2-3.76-3.755zM18.9 6.509l.655-.654a1.735 1.735 0 000-2.457L18.262 2.1a1.743 1.743 0 00-2.462 0l-.654.653z",
    fill: "currentColor"
  })));
}

export default SvgEdit;